import './styles/App.css'
import React, { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { BrowserRouter } from "react-router-dom";
import { NuqsAdapter } from "nuqs/adapters/react";
import { useAuthStore } from '../features/auth';
import { AppRouter } from './providers/Router';
import { setOnSessionExpired } from '../shared/config/axios';

function App() {
  const [queryClient] = useState(() => new QueryClient());
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    // Register session-expiry handler so the axios interceptor can clear auth state
    // via the store instead of doing a hard page reload.
    setOnSessionExpired((reason) => useAuthStore.getState().logout(reason));
    checkAuth();
  }, [checkAuth]);
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <NuqsAdapter>
          <AppRouter />
        </NuqsAdapter>
      </BrowserRouter>
    </QueryClientProvider>

  );
}

export default App;